// extracted by mini-css-extract-plugin
export default {"sociallink":"SocialLink_sociallink__471Vi","sociallink__icon":"SocialLink_sociallink__icon__tPpLv"};